(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["archive-drop"] && !Shopify.designMode) return;
  try {
    
  class ArchiveVideoStage extends HTMLElement {
    connectedCallback() {
      this.playerItems = Array.from(this.querySelectorAll('[data-player-item]'));
      this.nextItems = Array.from(this.querySelectorAll('[data-next-item]'));
      this.nextRow = this.querySelector('[data-next-row]');
      this.titleEl = this.querySelector('[data-stage-title]');
      this.subEl = this.querySelector('[data-stage-sub]');
      this.prevBtn = this.querySelector('[data-stage-prev]');
      this.nextBtn = this.querySelector('[data-stage-next]');

      this.querySelectorAll('[data-next-btn]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const item = btn.closest('[data-next-item]');
          this.activate(Number(item.dataset.index));
        });
      });

      this.setupNext();

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));

      this.player = this.querySelector('.archive-drop__player');
      this.fsBtn = this.querySelector('[data-stage-fullscreen]');
      if (this.fsBtn && this.player) {
        this.fsBtn.addEventListener('click', () => this.toggleFullscreen());
        ['fullscreenchange', 'webkitfullscreenchange'].forEach((evt) =>
          document.addEventListener(evt, () => this.syncFullscreenState())
        );
      }

      // Every video autoplays muted (browsers won't allow it any other
      // way) — this just lets a visitor opt into sound. The chosen state
      // carries over when switching videos (see activate() below).
      this.muted = true;
      this.muteBtn = this.querySelector('[data-stage-mute]');
      if (this.muteBtn) this.muteBtn.addEventListener('click', () => this.toggleMute());

      // The autoplay attribute alone doesn't always start the first clip
      // (it can lose the race with page load or get skipped by the browser),
      // so explicitly play the active clip whenever the player is on
      // screen, and pause it when it scrolls away.
      if (this.player && 'IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          this.inView = entries[0].isIntersecting;
          const active = this.playerItems.find((item) => item.classList.contains('is-active'));
          const video = active && active.querySelector('video');
          if (!video) return;
          if (this.inView) video.play().catch(() => {});
          else video.pause();
        }, { threshold: 0.25 }).observe(this.player);

        // Dawn's global pauseAllMedia() (fired when any deferred media loads —
        // e.g. a 3D product card further down the page) pauses every <video>
        // on the page. There are no visible controls here, so a pause we
        // didn't ask for is never the visitor's — resume the active clip.
        this.playerItems.forEach((item) => {
          const video = item.querySelector('video');
          if (!video) return;
          video.addEventListener('pause', () => {
            if (!item.classList.contains('is-active') || !this.inView || document.hidden) return;
            setTimeout(() => {
              if (video.paused && item.classList.contains('is-active') && this.inView) video.play().catch(() => {});
            }, 60);
          });
        });
      }
    }

    setupNext() {
      if (!this.nextRow || this.nextItems.length < 2) return;
      this.layoutNext(0);
    }

    // Lays every "coming up next" card out relative to whichever one is
    // active: active sits centered at full size; each step away shrinks,
    // dims and grays the card and pushes it sideways, so they stack like
    // a hand of cards peeking from behind the active one and get clipped
    // by the viewport's edge once they're far enough out. Offsets wrap
    // the short way round the list (so index 0 sits just next to the
    // last item, not all the way across).
    layoutNext(index) {
      if (!this.nextRow) return;
      const n = this.nextItems.length;
      const GAP = 78;
      this.nextItems.forEach((item, i) => {
        let offset = i - index;
        if (offset > n / 2) offset -= n;
        if (offset < -n / 2) offset += n;
        const abs = Math.abs(offset);
        const scale = Math.max(0.55, 1 - abs * 0.18);
        const opacity = Math.max(0.15, 1 - abs * 0.32);
        item.style.transform = `translateX(${offset * GAP}px) scale(${scale})`;
        item.style.opacity = String(opacity);
        item.style.filter = abs > 0 ? `grayscale(${Math.min(1, abs * 0.5)})` : 'none';
        item.style.zIndex = String(100 - abs);
      });
    }

    toggleMute() {
      this.muted = !this.muted;
      this.muteBtn.setAttribute('aria-pressed', this.muted ? 'false' : 'true');
      this.muteBtn.setAttribute('aria-label', this.muted ? 'Unmute' : 'Mute');
      const active = this.playerItems.find((item) => item.classList.contains('is-active'));
      const video = active && active.querySelector('video');
      if (video) video.muted = this.muted;
    }

    toggleFullscreen() {
      const fsEl = document.fullscreenElement || document.webkitFullscreenElement;
      if (fsEl) {
        (document.exitFullscreen || document.webkitExitFullscreen).call(document);
      } else {
        const req = this.player.requestFullscreen || this.player.webkitRequestFullscreen;
        if (req) req.call(this.player);
      }
    }

    syncFullscreenState() {
      const fsEl = document.fullscreenElement || document.webkitFullscreenElement;
      this.player.classList.toggle('is-fullscreen', fsEl === this.player);
    }

    step(delta) {
      const current = this.playerItems.findIndex((item) => item.classList.contains('is-active'));
      const total = this.playerItems.length;
      this.activate((current + delta + total) % total);
    }

    activate(index) {
      const active = this.playerItems[index];
      this.playerItems.forEach((item, i) => {
        const isActive = i === index;
        item.classList.toggle('is-active', isActive);
        const video = item.querySelector('video');
        if (!video) return;
        if (isActive) {
          video.muted = this.muted;
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
      this.nextItems.forEach((item, i) => item.classList.toggle('is-active', i === index));
      this.layoutNext(index);

      if (this.titleEl) this.titleEl.textContent = active.dataset.title || '';
      if (this.subEl) this.subEl.textContent = active.dataset.sub || '';
    }
  }

  if (!customElements.get('archive-video-stage')) customElements.define('archive-video-stage', ArchiveVideoStage);

  class ArchivePhotoGrid extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-photo-btn]'));
      this.lightbox = this.querySelector('[data-lightbox]');
      this.img = this.querySelector('[data-lightbox-img]');
      this.closeBtn = this.querySelector('[data-lightbox-close]');
      this.prevBtn = this.querySelector('[data-lightbox-prev]');
      this.nextBtn = this.querySelector('[data-lightbox-next]');
      this.index = 0;

      this.items.forEach((btn, i) => btn.addEventListener('click', () => this.open(i)));
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));
      if (this.lightbox) {
        this.lightbox.addEventListener('click', (e) => {
          if (e.target === this.lightbox) this.close();
        });
      }
      document.addEventListener('keydown', (e) => {
        if (!this.lightbox || !this.lightbox.classList.contains('is-open')) return;
        if (e.key === 'Escape') this.close();
        if (e.key === 'ArrowLeft') this.step(-1);
        if (e.key === 'ArrowRight') this.step(1);
      });
    }

    open(i) {
      this.index = i;
      this.render();
      this.lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    step(delta) {
      const total = this.items.length;
      this.index = (this.index + delta + total) % total;
      this.render();
    }

    render() {
      const btn = this.items[this.index];
      this.img.src = btn.dataset.full;
      this.img.alt = btn.dataset.alt || '';
    }
  }

  if (!customElements.get('archive-photo-grid')) customElements.define('archive-photo-grid', ArchivePhotoGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["br-agent"] && !Shopify.designMode) return;
  try {
    
  class BrAgent extends HTMLElement {
    connectedCallback() {
      this.endpoint = this.dataset.endpoint || '';
      this.fallbackEmail = this.dataset.fallbackEmail || '';
      this.log = this.querySelector('.br-agent__log');
      this.faq = this.querySelector('.br-agent__faq');
      this.form = this.querySelector('.br-agent__form');
      this.input = this.querySelector('.br-agent__input');
      this.sendBtn = this.querySelector('.br-agent__send');
      this.messages = [];
      this.busy = false;
      this.engaged = false;
      if (this.endpoint) this.setAttribute('data-online', '');

      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.submit(this.input.value); });
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); this.form.requestSubmit(); }
      });
      this.input.addEventListener('input', () => {
        this.autosize();
        if (this.input.value.trim()) this.engage();
      });
      this.querySelectorAll('.br-agent__faq-q').forEach((b) =>
        b.addEventListener('click', () => this.submit(b.dataset.say, b.dataset.answer || ''))
      );
    }

    engage() {
      if (this.engaged) return;
      this.engaged = true;
      this.classList.add('br-agent--engaged');
      if (this.faq) {
        this.faq.style.opacity = '0';
        const node = this.faq;
        setTimeout(() => { if (node && node.parentNode) node.remove(); }, 260);
        this.faq = null;
      }
    }

    autosize() {
      this.input.style.height = 'auto';
      this.input.style.height = Math.min(this.input.scrollHeight, 120) + 'px';
    }

    addMsg(role, text) {
      const el = document.createElement('div');
      el.className = 'br-agent__msg br-agent__msg--' + role;
      const safe = String(text).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      const linked = safe.replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1" target="_blank" rel="noopener">$1<\/a>');
      el.innerHTML = linked.split(/\n{2,}/).map((p) => '<p>' + p.replace(/\n/g, '<br>') + '<\/p>').join('');
      this.log.appendChild(el);
      this.log.scrollTop = this.log.scrollHeight;
      return el;
    }

    showTyping() {
      const t = document.createElement('div');
      t.className = 'br-agent__typing';
      t.innerHTML = '<i><\/i><i><\/i><i><\/i>';
      this.log.appendChild(t);
      this.log.scrollTop = this.log.scrollHeight;
      return t;
    }

    setBusy(v) { this.busy = v; this.sendBtn.disabled = v; this.input.disabled = v; }

    async submit(raw, cannedAnswer) {
      const text = (raw || '').trim();
      if (!text || this.busy) return;
      this.engage();
      this.input.value = '';
      this.autosize();

      this.addMsg('user', text);

      if (!this.endpoint) {
        if (cannedAnswer) this.addMsg('bot', cannedAnswer);
        else this.addMsg('sys', 'BeyondAgent is not connected yet. Email ' + this.fallbackEmail + ' and we will get back to you.');
        return;
      }

      this.messages.push({ role: 'user', content: text });
      this.setBusy(true);
      const typing = this.showTyping();

      try {
        const res = await fetch(this.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            messages: this.messages,
            context: {
              customer_name: this.dataset.customerName || null,
              customer_email: this.dataset.customerEmail || null,
              page: location.pathname
            }
          })
        });
        typing.remove();
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const data = await res.json();
        const reply = (data && data.reply) ? String(data.reply) : 'Sorry - something went wrong. Try again in a moment.';
        this.messages.push({ role: 'assistant', content: reply });
        this.addMsg('bot', reply);
        if (data && data.escalated) this.addMsg('sys', 'Someone on the BeyondRepair team has been pinged and will follow up.');
      } catch (err) {
        typing.remove();
        this.addMsg('sys', 'Could not reach the agent. Email ' + this.fallbackEmail + ' or try again.');
      } finally {
        this.setBusy(false);
        this.input.focus();
      }
    }
  }

  if (!customElements.get('br-agent')) customElements.define('br-agent', BrAgent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class BrNav extends HTMLElement {
    connectedCallback() {
      this.toggleBtn = this.querySelector('.br-nav__toggle');
      this.scrim = this.querySelector('.br-nav__scrim');
      this.panel = this.querySelector('.br-nav__panel');
      if (!this.toggleBtn || !this.scrim || !this.panel) return;

      this._onKey = (e) => {
        if (e.key === 'Escape' && this.classList.contains('br-nav--open')) this.close();
      };

      this.panel.inert = true;

      this.toggleBtn.addEventListener('click', () => {
        this.classList.contains('br-nav--open') ? this.close() : this.open();
      });
      this.scrim.addEventListener('click', () => this.close());
    }

    open() {
      this.classList.add('br-nav--open');
      this.toggleBtn.setAttribute('aria-expanded', 'true');
      this.panel.setAttribute('aria-hidden', 'false');
      this.panel.inert = false;
      document.documentElement.classList.add('br-nav-lock');
      document.addEventListener('keydown', this._onKey);
      const target = this.panel.querySelector('.br-nav__link.is-active') || this.panel.querySelector('a, button');
      if (target) target.focus({ preventScroll: true });
    }

    close() {
      this.classList.remove('br-nav--open');
      this.toggleBtn.setAttribute('aria-expanded', 'false');
      this.panel.setAttribute('aria-hidden', 'true');
      this.panel.inert = true;
      document.documentElement.classList.remove('br-nav-lock');
      document.removeEventListener('keydown', this._onKey);
      this.toggleBtn.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('br-nav')) customElements.define('br-nav', BrNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password-content"] && !Shopify.designMode) return;
  try {
    
  /* A trigger toggles .is-open on the element, which slides its
     .lockgate__panel open. The trigger is either a .lockgate__trigger
     inside, or an outside element named by data-trigger (the password
     gate uses the logo button in main-password-header). */
  class LockGate extends HTMLElement {
    connectedCallback() {
      const sel = this.dataset.trigger;
      this.btn = sel ? document.querySelector(sel) : this.querySelector('.lockgate__trigger');
      this.input = this.querySelector('input:not([type="hidden"])');
      if (!this.btn) return;
      this.btn.addEventListener('click', () => this.toggle());

      // Reopen after a failed password / a signup post so the message shows.
      if (this.querySelector('[data-open]')) this.classList.add('is-open');
      this.sync();
      if (this.classList.contains('is-open')) {
        requestAnimationFrame(() => this.input && this.input.focus());
      }
    }
    toggle() {
      this.classList.toggle('is-open');
      this.sync();
      if (this.classList.contains('is-open')) {
        requestAnimationFrame(() => this.input && this.input.focus());
      }
    }
    sync() {
      this.btn.setAttribute('aria-expanded', String(this.classList.contains('is-open')));
    }
  }
  if (!customElements.get('lock-gate')) customElements.define('lock-gate', LockGate);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
